namespace $.$$ {
	
	$mol_style_define( $giper_baza_land_page, {
		
		flex: {
			basis: `60rem`,
			grow: 1,
		},
		
		Pawn_link: {
			flex: {
				grow: 1,
			},
		},
		
		Size: {
			padding: $mol_gap.text,
		},
		
	} )
	
}
